import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Spin, Pagination, Empty } from "antd"

import AnswerCard from "../AnswerCard"
import empty_meditions from "images/emptyQuestionsReports.svg"
import { getSentimentAnalysisAnswersApi } from "../../../../utils/routes/routes-report"
import { validate } from "../../../../utils/functions"
import { loadTexts } from "../../../../utils/i18n"
import "./index.less"

const DEFAULT_PAGE_SIZE = 6

// Respuestas paginadas + filtradas del lado del servidor vía
// GET reports/measure/{measure}/sentiment-analysis/answers — reemplaza al
// mecanismo de paginación/filtro client-side de QualitativeQuestionList para
// esta vista. No comparte redux con QualitativeQuestionList: fetch propio,
// contenido a este componente.
export function AnswersList(props) {
  const {
    measure,
    division,
    isLeadership,
    question,
    sentimentFilter,
    textFilter,
    pagination,
    onTotalChange,
  } = props

  const intl = loadTexts("reports_qualitative_questions_view")

  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE)
  const [isLoading, setIsLoading] = useState(true)
  const [answers, setAnswers] = useState([])
  const [total, setTotal] = useState(0)

  // Cualquier cambio de filtro vuelve a la página 1.
  useEffect(() => {
    setPage(1)
  }, [measure, division, isLeadership, question, sentimentFilter, textFilter])

  useEffect(() => {
    if (!validate.exist(measure)) return

    let cancelled = false
    setIsLoading(true)

    getSentimentAnalysisAnswersApi({
      id_measure: measure,
      // Líder específico → filter[leader] (id_position). División → id_division.
      // Nunca los dos a la vez: "division" representa uno u otro según
      // isLeadership, nunca ambos conceptos simultáneamente.
      id_division: isLeadership ? null : division || null,
      "filter[leader]": isLeadership ? division || null : null,
      "filter[question]": question || null,
      "filter[sentiment]": sentimentFilter || null,
      "filter[search]": textFilter || null,
      per_page: pageSize,
      page,
    })
      .then((response) => {
        if (cancelled || !response) return
        const meta = response.meta || {}
        setAnswers(response.data || [])
        setTotal(meta.total || 0)
        if (onTotalChange) onTotalChange(meta.total || 0)
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [measure, division, isLeadership, question, sentimentFilter, textFilter, page, pageSize])

  const showEmpty = !isLoading && answers.length === 0

  return (
    <div className="AnswersList-container">
      {showEmpty ? (
        <Empty
          style={{ color: "#828282" }}
          image={empty_meditions}
          description={
            <span style={{ margin: "0 auto", maxWidth: 440, display: "block" }}>
              {intl.noResultsFound}
            </span>
          }
          className="ReportsHome-empty-fix"
        />
      ) : (
        <>
          <div className="AnswersList">
            {answers.map((answer, i) => (
              <AnswerCard
                key={answer.id_answer || i}
                title={answer.question_name || answer.name}
                description={answer.value}
                sentiment={answer.sentiment_result}
                division={answer.division_name}
              />
            ))}
          </div>
          {pagination && (
            <Pagination
              current={page}
              pageSize={pageSize}
              pageSizeOptions={["6", "15", "25", "50", "100"]}
              showSizeChanger
              onChange={(nextPage, nextPageSize) => {
                setPage(nextPage)
                setPageSize(nextPageSize)
              }}
              total={total}
            />
          )}
        </>
      )}
      {isLoading && (
        <div className="AnswersList-loading-overlay">
          <Spin size="large" />
        </div>
      )}
    </div>
  )
}

AnswersList.propTypes = {
  measure: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  division: PropTypes.number,
  isLeadership: PropTypes.bool,
  question: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  sentimentFilter: PropTypes.string,
  textFilter: PropTypes.string,
  pagination: PropTypes.bool,
  onTotalChange: PropTypes.func,
}

AnswersList.defaultProps = {
  pagination: true,
}

export default AnswersList
